
import { useUserData, UserProfile } from "@/hooks/users/useUserData";

export const useUserDataExtended = () => {
  const userData = useUserData();

  // This method will now just use the profile completeness data that's already included
  // in the profiles data without making additional queries
  const refetchWithCompleteness = async () => {
    await userData.refetch();
    
    if (userData.users && userData.users.length > 0) {
      // The profile completeness data is now already included from the fetchUsers function
      return userData.users;
    }
    
    return userData.users;
  };

  return {
    ...userData,
    refetchWithCompleteness
  };
};
